import React, { useState, useEffect, Fragment } from 'react';
import { validateProperty, validate } from "../../Common"
import MessageModal from '../../../UI/Modal/MessageModal';
import { PageHeader } from '../../../Common';
import Joi from '@hapi/joi';
import { packageCreationSchemaObject } from '../packageCreationSchema';
import services from '../services';
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import TextField from '@material-ui/core/TextField';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../Common/services';
import tokenService from '../../../Common/tokenDecoder';

const screenCode = 'PACKAGE';

export function PackageCreationAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Package Creation");
    const [groups, setGroups] = useState([]);
    const [buttonName, setButtonName] = useState("Save");
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionpoint, setCollectionpoint] = useState([]);
    const [users, setUsers] = useState([]);
    const [vehicles, setVehicles] = useState([]);
    const [cards, setCards] = useState([]);
    const [password, setPassword] = useState({});
    const [userRemoveDropdown, setUserRemoveDropdown] = useState(false);
    const [isDropdownDisable, setIsDropdownDisable] = useState(false);
    const [userRemoveToggle, setUserRemoveToggle] = useState(false);
    const [editDisable, setEditDisable] = useState(false);
    const [isChanged, setIsChanged] = useState(0);
    const [packageCreation, setPackageCreation] = useState({
        packageID: '0',
        groupID: '0',
        operationEntityID: '0',
        collectionPointID: '0',
        aspNetUserId: '0',
        operationalCardID: '0',
        vehicleID: '0',
        packageCode: '',
        backupLoginPassword: '',
        confirmPassword: '',
        packageName: '',
        isActive: true,
        removeUser: false,
        edit: props.location.edit !== undefined
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "Save/ Edit success"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });

    const schema = Joi.object(packageCreationSchemaObject).options({ allowUnknown: true });
    const [allowedOperationEntities, setAllowedOperationEntities] = useState([]);

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setIsChanged(isChanged + 1);
    }, [packageCreation]);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
        resetDropdowns();
    }, [packageCreation.groupID]);

    useEffect(() => {
        trackPromise(
            getOperationCardForDropDown()
        )
    }, [packageCreation.collectionPointID]);

    useEffect(() => {
        trackPromise(
            getVehiclesForDropdown()
        )
    }, [packageCreation.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getCollectionPointsAndUsersForDropDown()
        )
        resetOperationCardDropdown();
    }, [packageCreation.operationEntityID]);


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITPACKAGE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });


        var token = tokenService.getUserDetailsFromTokenV2();
        setAllowedOperationEntities(token.operationEntities || []);
        if (data && edit) {
            setButtonName("Update");
            setTitle("Edit Package");
            setPackageCreationEditData();
            setIsDropdownDisable(true);
            checkSessionStateByPackageID();
        } else {
            setTitle("Add Package");
            setPackageCreation({
                ...packageCreation,
                groupID: token.groupID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        )
    }


    function resetOperationCardDropdown() {
        if (!edit || (edit && isChanged >= 2)) {
            setCollectionpoint([]);
            setUsers([]);
            setCards([]);

            setPackageCreation({
                ...packageCreation,
                collectionPointID: "0",
                aspNetUserId: "0",
                operationalCardID: "0",
                vehicleID: "0"
            });
        }
    }

    function resetDropdowns() {
        if (!edit || (edit && isChanged >= 2)) {
            setCollectionpoint([]);
            setUsers([]);
            setOperationEntity([]);
            setVehicles([]);
            setCards([]);

            setPackageCreation({
                ...packageCreation,
                collectionPointID: "0",
                aspNetUserId: "0",
                operationEntityID: "0",
                operationalCardID: "0",
                vehicleID: "0"
            });
        }
    }

    function setPackageCreationEditData() {

        if (data.aspNetUserId == null) {
            setUserRemoveDropdown(true);
        } else {
            setUserRemoveDropdown(false);
        }

        setPackageCreation({
            ...packageCreation,
            packageID: data.packageID,
            groupID: data.groupID.toString(),
            operationEntityID: data.operationEntityID.toString(),
            collectionPointID: data.collectionPointID.toString(),
            aspNetUserId: data.aspNetUserId === null ? "0" : data.aspNetUserId.toString(),
            vehicleID: data.vehicleID.toString(),
            operationalCardID: data.operationalCardID.toString(),
            packageCode: data.packageCode,
            packageName: data.packageName,
            createdBy: data.createdBy,
            createdDate: data.createdDate,
            isActive: data.isActive,
            removeUser: (data.aspNetUserId != 0 || data.aspNetUserId !== null)
        });
    }

    async function checkSessionStateByPackageID() {

        const response = await services.editDataIfSOSTrue(data.packageID);
        if (response.data) {
            setEditDisable(response.data);
            setIsDropdownDisable(response.data);
        }
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.GetFactoriesByGroupID(packageCreation.groupID);
        const allowedIDs = allowedOperationEntities.map(entity => entity.OperationEntityID);
        const filtered = Object.fromEntries(
            Object.entries(opEntities).filter(
                ([id, name]) => allowedIDs.includes(parseInt(id))
            )
        );
        setOperationEntity(filtered);
    }

    async function getCollectionPointsAndUsersForDropDown() {
        let collectionPonts;

        if (data && edit)
            collectionPonts = await services.GetCollectionPointsFilter(packageCreation.operationEntityID);
        else
            collectionPonts = await services.GetCollectionPointsFilter(packageCreation.operationEntityID);

        setCollectionpoint(collectionPonts);

        const users = await services.getAvailableUsers(packageCreation.operationEntityID, packageCreation.aspNetUserId);
        setUsers(users);
    }

    async function getOperationCardForDropDown() {
        const opCards = await services.GetAllCardsByCollectionPointID(packageCreation.collectionPointID, packageCreation.operationalCardID);
        setCards(opCards);
    }

    async function getVehiclesForDropdown() {
        const vehiclesList = await services.GetAllVehicles(packageCreation.operationEntityID);
        setVehicles(vehiclesList);
    }

    function handleChange(e) {
        const target = e.target;

        if (target.name === "packageCode") {
            if (target.value.length === 3) return false;
        }

        const value = target.name === 'isActive' || target.name === 'removeUser' ? target.checked : target.value;
        if (target.name === 'removeUser' && target.checked === true) {
            setUserRemoveDropdown(false);
            setUserRemoveToggle(true);

            var filteredUsers = [];
            for (const item of Object.entries(users)) {
                // if (item[0] !== packageCreation.aspNetUserId.toString()) {
                //     filteredUsers[item[0]] = item[1];
                // }
                filteredUsers[item[0]] = item[1];
            }
            // setUsers(filteredUsers);

            setPackageCreation({
                ...packageCreation,
                aspNetUserId: "0",
                removeUser: true,
            });
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, packageCreationSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setPackageCreation({
            ...packageCreation,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleRemoveUser(e) {
        setUserRemoveToggle(false);

        var filteredUsers = [];
        for (const item of Object.entries(users)) {
            //if (item[0] !== packageCreation.aspNetUserId.toString()) {
            filteredUsers[item[0]] = item[1];
            //}
        }

        //   setUsers(filteredUsers);

        setPackageCreation({
            ...packageCreation,
            aspNetUserId: "0",
            removeUser: false,
        });
    }

    async function handleSave(e) {
        e.preventDefault();
        const errorMessages = validate(schema, packageCreation);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        if (packageCreation.backupLoginPassword == packageCreation.confirmPassword) {
            setPassword(packageCreation.confirmPassword);
            if (!edit) {
                const response = await services.savePackageCreation(packageCreation);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
                afterSuccessfulyChanged(response.statusCode);
            } else {
                const response = await services.editData(packageCreation);
                setMessageModel({ ...messageModel, hidden: false, type: response.statusCode, disciption: response.message });
                afterSuccessfulyChanged(response.statusCode);
            }
        }
        else {
            setMessageModel({ ...messageModel, hidden: false, type: "Error", disciption: "Password Mismatch" });
            setTimeout(() => {
                setMessageModel({ ...messageModel, hidden: true });
            }, 1500);
        }

    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState();
            setTimeout(() => {
                props.history.push({ pathname: '/packagecreation' });
            }, 1500);
        }
    }

    function clearState() {
        var token = tokenService.getUserDetailsFromToken();
        setPackageCreation({
            ...packageCreation,
            groupID: permissionList.isGroupFilterEnabled ? '0' : token.groupID,
            operationEntityID: permissionList.isOperationEntityFilterEnabled ? '0' : token.operationEntityID,
            operationEntityTypeID: '0',
            collectionpointType: '0',
            collectionPointID: '0',
            aspNetUserId: '0',
            vehicleID: '0',
            operationalCardID: '0',
            backupLoginPassword: '',
            confirmPassword: '',
            packageCode: '',
            packageName: '',
            isActive: true,
            removeUser: false
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }


    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    buttonText="Back to Listing"
                                    path="/packagecreation"
                                    isChanged={isChanged}
                                    clearPage={clearState}
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => trackPromise(handleSave(e))} disabled={false}>

                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            disabled={isDropdownDisable || !permissionList.isGroupFilterEnabled}
                                            id="groupID"
                                            name="groupID"
                                            value={packageCreation.groupID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            disabled={isDropdownDisable || !permissionList.isOperationEntityFilterEnabled}
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            value={packageCreation.operationEntityID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col">
                                        <InputLabel shrink id="collectionPointID">Collection point *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionPointID"
                                            disabled={isDropdownDisable}
                                            id="collectionPointID"
                                            name="collectionPointID"
                                            value={packageCreation.collectionPointID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Collection point--</MenuItem>
                                            {generateDropDownMenu(collectionpoint)}
                                        </Select>
                                        {errors["collectionPointID"] && <FormHelperText error>{errors["collectionPointID"]}</FormHelperText>}
                                    </div>
                                </div>
                                <div className="form-group row">


                                    <div className="col">
                                        <InputLabel shrink id="operationalCardID">Operation Card *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationalCardID"
                                            disabled={isDropdownDisable}
                                            id="operationalCardID"
                                            name="operationalCardID"
                                            value={packageCreation.operationalCardID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Operation Card--</MenuItem>
                                            {generateDropDownMenu(cards)}
                                        </Select>
                                        {errors["operationalCardID"] && <FormHelperText error>{errors["operationalCardID"]}</FormHelperText>}
                                    </div>
                                    <div className="col">
                                        <InputLabel shrink id="aspNetUserId">User *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="aspNetUserId"
                                            disabled={editDisable}
                                            id="aspNetUserId"
                                            name="aspNetUserId"
                                            value={packageCreation.aspNetUserId}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select User--</MenuItem>
                                            {generateDropDownMenu(users)}
                                        </Select>
                                        {errors["aspNetUserId"] && <FormHelperText error>{errors["aspNetUserId"]}</FormHelperText>}
                                    </div>

                                    <div hidden={!edit}>
                                        <label>Remove User</label>
                                        <div className="form-group row">
                                            <div className="col-md pb-1">
                                                <input
                                                    disabled={userRemoveToggle}
                                                    className="mr-2"
                                                    id="removeUser"
                                                    switch="none"
                                                    //disabled={editDisable}
                                                    type="checkbox"
                                                    name="removeUser"
                                                    onChange={(e) => handleRemoveUser(e)}
                                                    checked={packageCreation.removeUser}
                                                />
                                                <label htmlFor="removeUser" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col">
                                        <InputLabel shrink id="vehicleID">Vehicle</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="vehicleID"
                                            disabled={editDisable}
                                            id="vehicleID"
                                            name="vehicleID"
                                            value={packageCreation.vehicleID}
                                            onChange={(e) => handleChange(e)}>
                                            <MenuItem value="0">--Select Vehicle--</MenuItem>
                                            {generateDropDownMenu(vehicles)}
                                        </Select>
                                        {errors["vehicleID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["vehicleID"]}</FormHelperText>)}

                                    </div>


                                </div>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Package Code *"
                                            name="packageCode"
                                            id="packageCode"
                                            disabled={editDisable}
                                            value={packageCreation.packageCode}
                                            type="number"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["packageCode"] && <FormHelperText error>{errors["packageCode"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField fullWidth label="Package Name *"
                                            name="packageName"
                                            id="packageName"
                                            disabled={editDisable}
                                            value={packageCreation.packageName}
                                            type="text"
                                            onChange={(e) => handleChange(e)} />
                                        {errors["packageName"] && <FormHelperText error>{errors["packageName"]}</FormHelperText>}
                                    </div>
                                    {edit ? null :
                                        <div className="col-md pb-1">
                                            <TextField fullWidth label="Backup Login Password *"
                                                name="backupLoginPassword"
                                                id="backupLoginPassword"
                                                value={packageCreation.backupLoginPassword}
                                                type="password"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["backupLoginPassword"] && <FormHelperText error>{errors["backupLoginPassword"]}</FormHelperText>}                                        </div>}
                                    {edit ? null :
                                        <div className="col-md pb-1">
                                            <TextField fullWidth label="Confirm Password *"
                                                name="confirmPassword"
                                                id="confirmPassword"
                                                value={packageCreation.confirmPassword}
                                                type="password"
                                                onChange={(e) => handleChange(e)} />
                                            {errors["confirmPassword"] && <FormHelperText error>{errors["confirmPassword"]}</FormHelperText>}                                        </div>}

                                </div>

                                <label>Active</label>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <input
                                            className="mr-2"
                                            id="isActive"
                                            disabled={editDisable}
                                            switch="none"
                                            type="checkbox"
                                            name="isActive"
                                            onChange={(e) => handleChange(e)}
                                            checked={packageCreation.isActive}
                                        />
                                        <label htmlFor="isActive" data-on-label="Yes"
                                            data-off-label="No"></label>
                                    </div>
                                </div>

                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, packageCreation)}
                                        type="submit"
                                        className="btn btn-primary"
                                        //disabled={editDisable}
                                        value={buttonName}
                                    />
                                    <input
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        disabled={editDisable}
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );

}